export default __webpack_public_path__ + "static/media/mod-materyal.eb0aadbc.png";